import { css } from "@emotion/react";

export const app = () => css({ textAlign: "center" });
export const dialogTitle = () => css({ textAlign: "center" });
